<template>
    <v-dialog-old ref="dialog" id="account" @shown="onShownEvent" @hidden="resetComponentData()" :onCloseEsc="onclose">
        <dialog-metro
            ref="metroDialog"
            :checked-options="M.metros"
            :metro-options="metroOptions"
            :city="M.city"
            @confirm="onConfirmMetros"/>

        <dialog-clinic-types
            ref="clinicTypesDialog"
            v-model="M.types"
            :proprietary="M.proprietary"
            :type-options="typeOptions"/>

        <image-cropper
            ref="cropper"
            :img="M.img"
            type="clinics"
            @crop-upload-success="cropUploadSuccess"
            upload-url="/imageCropperNew/clinics"
        />

        <a href="#close" style="text-align: center" @click.stop.prevent="onclose"></a>
        <ValidationObserver ref="clinicEditForm">
        <form >
            <fieldset :disabled="!canEdit">
                <legend>Учетная запись</legend>
                <div class="alert alert-warning" v-if="M.moderationNeeded" style="margin-bottom: 10px;">
                    Внимание! Изменения отправлены на проверку. После проверки менеджером обновлённая информация
                    появится на сайте.
                </div>
                <table class="grid">
                    <tr>
                        <td width="700" valign="top" style="padding-top: 5px;">
                            <table class="grid">
                                <tr>
                                    <td valign="top" width="150">
                                        <drag-and-drop @fileDropped="openCropWithNewFile">
                                            <div class="imageCropper">
                                                <button type="button" v-show="M.img !== ''"
                                                        class="resetBtn small redHover" tooltip="Удалить логотип"
                                                        @click.prevent.stop="imageCropperDelete">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                                <img src=""
                                                     :src="M.img ? storagePublicUrl + '/images/clinics/150x150/' + M.img : ''"
                                                     width="150" height="150" @click.prevent.stop="imageCropperOpen"
                                                     style="cursor: pointer; background-image: url(/_assets/pic_clinic.svg);"/>

                                                <i class="button small" @click.prevent.stop="openClinicPage"
                                                        width="150"
                                                        v-tooltip="`${$parent.$parent.frontendUrl}/${M.city}/clinic/${M.url}`"
                                                        :disabled="!M.id" style="margin: 5px 0 !important;">
                                                    <i class="fas fa-link"></i>
                                                    Показать на сайте
                                                </i>
                                            </div>
                                        </drag-and-drop>
                                    </td>
                                    <td valign="top">
                                        <vee-textarea
                                            v-model="M.name"
                                            taClass="large"
                                            placeholder="Название"
                                            :readonly="true"
                                            :v-beautify="'capitalize itemclean typograf'" rules="required"
                                            taStyle="min-height: 128px"
                                            autofocus
                                        ></vee-textarea>
                                         <label>Форма собственности</label>
                                         <v-select
                                             v-model="M.proprietary"
                                             :disabled="true"

                                             :options="[
                                                            { value: 'private', text: 'Частная' },
                                                            { value: 'municipal', text: 'Государственная' }
                                                        ]"
                                         ></v-select>
                                    </td>
                                </tr>
                            </table>
                            <table class="grid">
                                <tr>
                                    <td width="25%">
                                        <label>Город</label>
                                        <ValidationProvider rules="required" v-slot="{ errors }">
                                            <v-select
                                                @close="recalcCityHandler"
                                                v-model="M.city"
                                                :class="{ 'hasError': errors[0]}"
                                                v-tooltip.right="{
                                                                content: errors[0],
                                                                template: $errTemplate,
                                                            }"
                                                :disabled="M.id !== ''"
                                                :options='
                                                    cityOptions.map(({ text, value }) => {
                                                        return {
                                                            text,
                                                            value
                                                        }
                                                    })
                                                '
                                            ></v-select>
                                        </ValidationProvider>
                                    </td>

                                    <td v-if="localityOptions.find(findByCity)" width="25%">
                                        <label>Населенный пункт</label>
                                        <v-select
                                            @close="recalcLocalityHandler"
                                            v-model="M.locality"
                                            :options='[
                                                {
                                                    value: "",
                                                    text: "\u00a0"
                                                },
                                                ...localityOptions.filter(findByCity).map(({ text, value }) => {
                                                    return {
                                                        text,
                                                        value
                                                    };
                                                })
                                            ]'
                                        ></v-select>
                                    </td>
                                    <td width="25%" v-if="districtOptions.filter(findByCity)">
                                        <label>Район</label>
                                        <v-select
                                            :disabled="true"
                                            v-model="M.district"
                                            :options='filteredDistrictOptions'
                                        ></v-select>
                                    </td>
                                    <td width="25%" v-if="areaOptions.find(findByCity)">
                                        <label>Округ</label>
                                        <v-select
                                            v-model="M.area"
                                            :options='
                                                areaOptions.filter(findByCity).map(({ text, value }) => {
                                                    return {
                                                        text,
                                                        value
                                                    };
                                                })
                                            '
                                        ></v-select>
                                    </td>
                                </tr>
                            </table>

                            <table class="grid">
                                <tr>
                                    <td>
                                        <vee-input
                                            @blur="recalcAddressHandler"
                                            v-model="M.address"
                                            rules="required"
                                            placeholder="Адрес"
                                        />
                                    </td>
                                    <td width="140">
                                        <vee-button :disabled="M.city === ''" errText="Требуется указать клинику на карте!"
                                            @click="showAddressOnMap" :rules="{required: !M.markLat}"
                                                class="small">
                                            <i class="fad fa-map-location-dot"
                                               v-tooltip="`${(+M.markLat).toFixed(6)}, ${(+M.markLong).toFixed(6)}`"></i>
                                            Показать на карте
                                        </vee-button>
                                    </td>
                                </tr>
                            </table>

                            <div v-if="metroOptions.find(findByCity)">
                                <label>Метро для анкеты</label>
                                <div class="textarea" @click.prevent.stop="editMetros">
                                    <span class="comma">
                                        <span v-for="(metro, index) in M.metros" :key="index">
                                            {{ metroOptions.find(item => item.value === metro).text }}</span>
                                    </span>
                                    <button type="button" class="tiny">Выбрать метро</button>
                                </div>
                            </div>

                            <label>Категории</label>
                            <ValidationProvider  rules="required|clinicTypes" v-slot="{ errors }">
                            <div class="textarea" :disabled="M.proprietary === ''" :class="{ 'hasError': errors[0]}" v-model="M.types"
                                v-tooltip="{
                                content: errors[0],
                                template: $errTemplate,
                                }"
                                 @click.prevent.stop="editTypes">
                                <span class="comma">
                                    <span v-for="type in M.types">{{ typeOptions.find(item => item.value === type).text }}</span>
                                </span>
                                <button v-if="M.proprietary !== ''" type="button" class="tiny">Выбрать</button>
                            </div>
                            </ValidationProvider>

                        </td>
                        <td valign="top" style="width:480px;padding: 5px;min-width: 480px !important">
                            <div id="Ymap" style="width: 100%; height: 350px; background-color: #D0CFCF;"></div>
                        </td>
                    </tr>
                </table>

                <hr style="margin: 5px 0 5px 0"/>

                <table class="grid">
                    <tr>
                      <td valign="top" width="700">
                        <label>Страница ДОКТУ</label>
                        <div style="width:700px" class="input text-ellipsis">
                          <a :href="$parent.$parent.frontendUrl+'/'+(M.city === '' ? '—' : M.city)+'/clinic/'+M.url"
                             target="_blank"
                             class="text-ellipsis"
                          >
                            {{ $parent.$parent.frontendUrl.replace("https://", "") }}/{{
                              M.city === '' ? '—' : M.city
                            }}/clinic/{{ M.url }}
                          </a>
                        </div>
                        <div style="width:495px; display: inline-block">
                          <label>Официальное название</label>
                          <input v-model="M.nameOfficial"
                                 v-beautify.literal="'capitalize itemclean striptags typograf'">
                        </div>
                        <div style="width:200px;display: inline-block">
                          <label>Год основания</label>
                          <input min="1800" :max="new Date().getFullYear()" v-model="M.estYear" type="number" units="г">
                        </div>
                        <div style="width:320px; display: inline-block">
                          <label>ФИО главного врача</label>
                          <input v-model="M.chiefDoctor">
                        </div>
                        <div style="width:170px;display: inline-block">
                          <label>Прием по страховке</label>
                          <v-select
                              v-model="M.insuranceType"
                              :options=insuranceTypes
                          ></v-select>
                        </div>
                        <div style="width:200px;display: inline-block">
                          <label>Номер лицензии</label>
                          <input v-model="M.licenceNum"
                                 v-beautify.literal="'itemclean striptags typograf'">
                        </div>
                      </td>
                        <td width="250" style="display: flex; flex-direction: column;margin-top: -5px;">
                            <label style="margin-left: 25px;">Режим работы</label>

                            <div>
                                <span style="width: 20px; display: inline-block;">пн</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.monFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.monTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.monFrom)"
                                    :options="timeOptionsMon"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">вт</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.tueFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.tueTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.tueFrom)"
                                    :options="timeOptionsTue"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">ср</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.wedFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.wedTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.wedFrom)"
                                    :options="timeOptionsWed"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">чт</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.thuFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.thuTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.thuFrom)"
                                    :options="timeOptionsThu"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">пт</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.friFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.friTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.friFrom)"
                                    :options="timeOptionsFri"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">сб</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.satFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.satTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.satFrom)"
                                    :options="timeOptionsSat"
                                ></v-select>
                            </div>

                            <div>
                                <span style="width: 20px; display: inline-block;">вс</span>

                                <v-select
                                    style="width: 100px; display: inline-block;"
                                    v-model="M.workTime.sunFrom"
                                    :options="timeOptionsFull"
                                ></v-select>

                                <v-select
                                    v-model="M.workTime.sunTill"
                                    style="width: 100px; display: inline-block;"
                                    :disabled="['', 'off', '24h'].includes(M.workTime.sunFrom)"
                                    :options="timeOptionsSun"
                                ></v-select>
                            </div>
                        </td>
                        <td valign="top" width="250">
                            <div>
                                <label>
                                    <input type="checkbox" v-model="M.hasTerminal"/>
                                    <span>Есть оплата картой</span>
                                </label>
                                <label>
                                    <input type="checkbox" v-model="M.hasLaboratory"/>
                                    <span>Есть лаборатория</span>
                                </label>
                                <label>
                                    <input type="checkbox" v-model="M.hasParking"/>
                                    <span>Есть парковка</span>
                                </label>
                                <label>
                                    <input type="checkbox" v-model="M.hasHospital"/>
                                    <span>Есть стационар</span>
                                </label>
                            </div>
                        </td>
                    </tr>
                </table>

                <hr style="margin: 5px 0 5px 0"/>

                <label>Описание</label>
                <v-quill  ref="quill" v-model="M.description" :config="{eventsOnBlur: true}"/>

                <label>Фотографии клиники</label>

                <photo-gallery
                    id="photos"
                    v-model="M.photos"
                    :imagesBasePath="storagePublicUrl + '/images/clinicPhotos/120x120/'"
                    uploadUrl="clinics/uploadPhoto"
                    buttonText="Добавить<br>фотографии<br>клиники"
                    @file-uploaded="photosUploaded"
                ></photo-gallery>

                <hr style="margin: 5px 0 5px 0"/>

                <label>Лицензии клиники</label>

                <photo-gallery
                    id="licenses"
                    v-model="M.licences"
                    :imagesBasePath="storagePublicUrl + '/images/clinicLicences/Wx120/'"
                    uploadUrl="clinics/uploadLicence"
                    buttonText="Добавить<br>лицензии"
                    @file-uploaded="licenseUploaded"
                ></photo-gallery>
            </fieldset>
        </form>
        </ValidationObserver>
        <footer>
            <v-loading-component @click="onUpdate" v-if="canEdit">
                <template slot-scope="{ loadingClass }">
                    <button :disabled="!needSave" :class="[{green: needSave}, loadingClass]">Сохранить</button>
                </template>
            </v-loading-component>
            <template>
                <v-loading-component v-if="currentUser.isSupport" @click="loginAsSupport">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['blue', loadingClass]">Войти в учётную запись</button>
                    </template>
                </v-loading-component>
                <v-loading-component @click="loginAsNetwork" v-else-if="canActAsClinic">
                    <template slot-scope="{ loadingClass }">
                        <button :class="['blue', loadingClass]">Войти в учётную запись</button>
                    </template>
                </v-loading-component>
            </template>
        </footer>
    </v-dialog-old>
</template>

<script>
import Vue from "vue";

import DialogMetro from "@dialogs/common/clinics/MetroDialog";
import DialogClinicTypes from "@dialogs/common/clinics/ClinicTypesDialog";
import yMapsMixin from '@mixins/YMaps.vue';
import imageCropper from '@base/ImageCropper.vue';
import {mapState} from "vuex";
import {STORAGE_PUBLIC} from "@global/const";
import {TIME_OPTIONS} from "@global/const";
import PhotoGallery from "@common/PhotoGallery";
import CreateUserFieldset from "@common/CreateUser";
import dragAndDrop from '@base/DragAndDrop.vue';
import { initialState } from "./ClinicEditFields";
import Competitors from "@dialogs/components/clinic/Competitors";
export default {
    components: {
        Competitors,
        dragAndDrop,
        imageCropper,
        DialogMetro,
        DialogClinicTypes,
        PhotoGallery,
        CreateUserFieldset,
    },

    mixins: [yMapsMixin],
    props: {
        userOptions: {
            type: Array,
            required: false
        },
        competitors: {
            type: Array
        },
    },
    data () {
        return initialState();
    },
    filters: {
        formatTime(time) {
            function isDateEmpty(date) {
                return (
                    (typeof date === 'undefined') ||
                    (date === null) ||
                    (date === '') ||
                    (date === '0000-00-00') ||
                    (date === '0000-00-00 00:00:00')
                    // !moment(date).isValid() // долго
                );
            }
            if (isDateEmpty(time)) return '';

            if (time.substr(2, 1) === ':') {
                return time.substr(0, 5);

            } else {
                return time.substr(11, 5);
            }
        },
    },
    mounted () {
        this.$store.dispatch('dictionary/fetchAllOptions');
    },
    watch: {
        'M.proprietary' (val, old) {
            if (old !== ''){
                this.M.types = [];
                this.M.displayed_network = '';
            }
        },
        needSave (val){
            if (val){
                window.addEventListener("beforeunload", this.$root.beforeunloadEvent);
            }else{
                window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);
            }

        },
        'M.workTime.monFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.monTill = '';
            } else {
                this.timeOptionsMon = TIME_OPTIONS;
            }
        },
        'M.workTime.tueFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.tueTill = '';
            } else {
                this.timeOptionsTue = TIME_OPTIONS;
            }
        },
        'M.workTime.wedFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.wedTill = '';
            } else {
                this.timeOptionsWed = TIME_OPTIONS;
            }
        },
        'M.workTime.thuFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.thuTill = '';
            } else {
                this.timeOptionsThu = TIME_OPTIONS;
            }
        },
        'M.workTime.friFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.friTill = '';
            } else {
                this.timeOptionsFri = TIME_OPTIONS;
            }
        },
        'M.workTime.satFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.satTill = '';
            } else {
                this.timeOptionsSat = TIME_OPTIONS;
            }
        },
        'M.workTime.sunFrom'(val) {
            if (['', '24h', 'off'].includes(val)) {
                this.M.workTime.sunTill = '';
            } else {
                this.timeOptionsSun = TIME_OPTIONS;
            }
        },
    },
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
            cityOptions: state => state.dictionary.cityOptions,
            localityOptions: state => state.dictionary.localityOptions,
            districtOptions: state => state.dictionary.districtOptions,
            metroOptions: state => state.dictionary.metroOptions,
            areaOptions: state => state.dictionary.areaOptions,
            typeOptions: state => state.dictionary.typeOptions
        }),
        canEdit () {
            return this.$canAny(['network.clinics.*']) &&
                !(this.currentUser.isSupport && this.M.moderationNeeded)
        },
        canActAsClinic () {
            return this.$canAny(['network.clinics.*'])
        },

        needSave () {
            return this.Mhashcode !== null && (this.Mhashcode !== JSON.stringify(this.M).hashCode());
        },

        storagePublicUrl () {
            return STORAGE_PUBLIC;
        },

        filteredDistrictOptions: function () {
            return this.districtOptions.filter(this.findByCity).map(({ text, value }) => {
                return {
                    text,
                    value
                };
            })
        }
    },
    methods: {
        fetchUser(user) {
            if (user === null){
                Vue.delete(this.M,'user')
            }else{
                Vue.set(this.M,'user',user)
            }
        },
        recalcAddressHandler() {
            this.recalcMapModal('buffClinicAddress', 'address');
        },

        recalcCityHandler() {
            this.recalcMapModal('buffClinicCity', 'city');
        },

        recalcLocalityHandler() {
            this.recalcMapModal('buffClinicLocality', 'locality');
        },

        recalcMapModal(buffField, originField) {
            if (this[buffField]) {
                if (this[buffField] !== this.M[originField]) {
                    return () => this.$modal('Пересчитать координаты?',
                        {
                            name: 'Пересчитать',
                            callback: () => {
                                this[buffField] = this.M[originField];
                                this.showAddressOnMap();
                            }
                        },
                        {
                            name: 'Не пересчитывать',
                            callback: () => {
                                this[buffField] = this.M[originField];
                            }
                        }
                    )
                }
            } else {
                return () => {
                    this[buffField] = this.M[originField];
                }
            }
        },
      coordsToModel (coordsFromDragend) {
        this.$nextTick(function () {
          if (coordsFromDragend) {
            this.M.markLong = coordsFromDragend[1];
            this.M.markLat = coordsFromDragend[0];
          }
          //TODO что-то странное, там где я проверял поле всегда undef, надо будет проверить и сделать норм
          if (this.yMapPlacemark) {
            let coords = this.yMapPlacemark.geometry.getCoordinates();

            if (coords && !coordsFromDragend) {
              this.M.markLong = coords[1];
              this.M.markLat = coords[0];
            }
            this.M.mapZoom = this.yMap.getZoom();
          }

        });
      },
        onShownEvent (e) {
            ymaps.ready(() => {
                this.initMap();
                this.$nextTick(() => {
                    if (this.M.markLat !== 0 && this.M.markLong !== 0){
                        this.updateMap(this.M.markLat, this.M.markLong, this.M.mapZoom);
                    }
                })
            });
        },
        photosUploaded: function (uploadedImageUrls, position) {
          uploadedImageUrls.reverse().forEach((url) => {
            this.M.photos.splice(position,0,url)
          })
        },
        licenseUploaded (uploadedImageUrls, position) {
          uploadedImageUrls.reverse().forEach((url) => {
            this.M.licences.splice(position,0,url)
          })
        },
        findByCity (item) {
            return item.city === this.M.city;
        },

        onclose () {
            if (this.needSave === true) {
                let confirmationMessage = 'Изменения не сохранены.';

                if (confirm(confirmationMessage)) {
                    this.$refs.dialog.hide();
                }
            } else {
                this.$refs.dialog.hide();
            }
            window.location.hash = '';
        },
        read: function (id, e = null) {
            this.resetComponentData();

            let requestPromise = this.axios.get('clinics/read/' + id, {});

            requestPromise.then(response => {
                if (response.data.displayed_network === null){
                    response.data.displayed_network = '';
                }
                Vue.set(this, 'M', response.data);

                this.buffClinicAddress = this.M.address;
                this.buffClinicCity = this.M.city;
                this.buffClinicLocality = this.M.locality;
                this.$refs.dialog.show();
                setTimeout(() => {
                    this.Mhashcode = JSON.stringify(this.M).hashCode();
                }, 300)

            })

            return requestPromise;
        },

        onUpdate(btn) {
            if(!this.needSave){
                return;
            }
            btn.startLoadingAnimation();

            this.$refs.clinicEditForm.validate().then(success => {
                if (!success) {
                    const el = document.querySelector(".hasError:first-of-type");
                    if (el) {
                        el.scrollIntoView({behavior: "smooth"});
                    }
                    btn.stopLoadingAnimation()
                    return;
                }

                if (this.$refs.quill.inProcess) {
                    this.$refs.quill.quillEditor.setSelection(null)
                    setTimeout(() => {
                        this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                    }, 450)
                } else {
                    this.update().then(() => btn.stopLoadingAnimation(), () => btn.stopLoadingAnimation());
                }

            });
        },
      update() {

        let requestPromise = this.axios.post('clinics/update/' + this.M.id, this.M);

        requestPromise.then(() => {
          this.$refs.dialog.hide();
          this.$parent.$refs.table.update();
        }).catch((error) => {
        });

        return requestPromise;
      },

          updateDistrictName (data) {
            let oldDistrictName = (this.districtOptions.find(option => {
                return option.value === this.M.district && option.city === this.M.city;
            }) || {}).text || '[НЕ ЗАДАН]';

            let newDistrictName = (this.districtOptions.find(option => {
                return option.value === data.district && option.city === this.M.city;
            }) || {}).text || '[НЕ ЗАДАН]';

            if (oldDistrictName !== newDistrictName) {
                if (oldDistrictName === '[НЕ ЗАДАН]') {
                    this.M.district = data.district;
                    this.updateLocalityName(data);
                } else {
                    this.$modal("Заменить район <br><b>" + oldDistrictName + "</b> на <b>" + newDistrictName + "</b>?",
                        {
                            name: "Заменить",
                            callback: () => {
                                this.M.district = data.district;
                                this.updateLocalityName(data);
                            }
                        },
                        {
                            name: "Нет",
                            callback: () => {
                                this.updateLocalityName(data);
                            }
                        },
                        true, '', false
                    );
                }
            } else {
                this.updateLocalityName(data);
            }
        },

        updateLocalityName (data) {
            let oldLocalityName = (this.localityOptions.find(option => {
                return option.value === this.M.locality && option.city === this.M.city
            }) || {}).text || '[НЕ ЗАДАН]';

            let newLocalityName = (this.localityOptions.find(option => {
                return option.value === data.locality && option.city === this.M.city
            }) || {}).text || '[НЕ ЗАДАН]';

            if (oldLocalityName !== newLocalityName) {
                if (oldLocalityName === '[НЕ ЗАДАН]') {
                    this.M.locality = data.locality;
                    this.updateAreaName(data);
                } else {
                    this.$modal(`Заменить населенный пункт <br><b>${oldLocalityName}</b> на <b>${newLocalityName}</b>?`,
                        {
                            name: "Заменить",
                            callback: () => {
                                this.M.locality = data.locality;
                                this.updateAreaName(data);
                            }
                        },
                        {
                            name: "Нет",
                            callback: () => {
                                this.updateAreaName(data);
                            }
                        },
                        true, '', false
                    );
                }
            } else {
                this.updateAreaName(data);
            }
        },

        updateAreaName (data) {
            let oldAreaName = (this.areaOptions.find(option => {
                return option.value === this.M.area && option.city === this.M.city
            }) || {}).text || '[НЕ ЗАДАН]';

            let newAreaName = (this.areaOptions.find(option => {
                return option.value === data.area && option.city === this.M.city
            }) || {}).text || '[НЕ ЗАДАН]';

            if (oldAreaName !== newAreaName) {
                if (oldAreaName === '[НЕ ЗАДАН]') {
                    this.M.area = data.area;
                    this.updateMetroNames(data);
                } else {
                    this.$modal("Заменить округ <br><b>" + oldAreaName + "</b> на <b>" + newAreaName + "</b>?",
                        {
                            name: "Заменить",
                            callback: () => {
                                this.M.area = data.area;
                                this.updateMetroNames(data);
                            }
                        },
                        {
                            name: "Нет",
                            callback: () => {
                                this.updateMetroNames(data);
                            }
                        },
                        true, '', false
                    );
                }
            } else {
                this.updateMetroNames(data);
            }
        },

        updateMetroNames (data) {
            const mapMetroName = (el) => {
                return (this.metroOptions.find(option => option.value === el) || {}).text || '[НЕ ЗАДАН]';
            };

            let oldMetroNames = this.M.metros.map(mapMetroName).join(', ');
            let newMetroNames = data.metros.map(mapMetroName).join(', ');

            if (oldMetroNames !== newMetroNames) {
                if ((oldMetroNames === '[НЕ ЗАДАН]') || (oldMetroNames === '')) {
                    this.M.metros = data.metros;
                } else {
                    this.$modal("Заменить метро <br><b>" + oldMetroNames + "</b><br> на <br><b>" + newMetroNames + "</b>?",
                        {
                            name: "Заменить",
                            callback: () => {
                                this.M.metros = data.metros;
                            }
                        },
                        {
                            name: "Нет"
                        }
                    );
                }
            }
        },

        showAddressOnMap (e) {
            this.axios.post('/getCoordsByAddress', {
                city: this.M.city,
                locality: this.M.locality,
                address: this.M.address
            }).then(response => {
                const data = response.data;

                this.M.markLat = data.geoLat;
                this.M.markLong = data.geoLong;
                this.M.mapZoom = 16;

                this.M.searchMetros = data.searchMetros;
                this.M.searchMetrosManual = [];

                this.updateMap(this.M.markLat, this.M.markLong, this.M.mapZoom);

                this.updateDistrictName(data);
            });
        },

        openClinicPage () {
            window.open('http://doctu.ru/' + this.M.city + '/clinic/' + this.M.url, '_blank');
        },

        editTypes () {
            if (this.M.proprietary !== ''){
                setTimeout(() => {
                    this.$refs.clinicTypesDialog.$refs.dialog.show();
                }, 190);
            }

        },

        editMetros () {
            this.$refs.metroDialog.$refs.dialog.show();
        },

        onConfirmMetros (checkedOptions) {
            this.M.metros = checkedOptions;
            this.$refs.metroDialog.$refs.dialog.hide();
        },

         openMatchedClinicRoute() {
            this.axios.get('/clinics/firstRoute').then(response => {
                window.open(response.data.redirect, '_blank');
            });
        },

        loginAsNetwork: function (loginAsButton) {
            loginAsButton.startLoadingAnimation();
             window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

            this.axios.post( '/network/loginAsClinic', {'id': this.M.id}).then(response => {
                loginAsButton.stopLoadingAnimation();
                if (response.data.status === 'OK') {
                    this.openMatchedClinicRoute()
                }
            })     .catch(() => loginAsButton.stopLoadingAnimation());
        },

        loginAsSupport(loginAsButton) {
            loginAsButton.startLoadingAnimation();
            window.removeEventListener("beforeunload", this.$root.beforeunloadEvent);

            let data = {
                accountId: this.M.account_id,
                pathname: window.location.pathname
            };

            this.axios.post('/admin/loginAsSupport', data).then((response) => {
                if (response.data.status === 'OK') {
                    this.openMatchedClinicRoute()
                }
                loginAsButton.stopLoadingAnimation();
            }).catch(() => {
                loginAsButton.stopLoadingAnimation();
            });
        },

        /*** cropper functions ***/
        openCropWithNewFile (file) {
            this.$refs.cropper.preloadFile(file);
            this.$refs.cropper.showModal();
        },
        imageCropperDelete: function (event) {
            this.$modal("Удалить логотип?", {
                    name: 'Удалить',
                    callback: () => {
                        this.M.img = '';
                    }
                },
                {
                    name: 'Нет'
                }
            );
        },
        imageCropperOpen () {
            if(this.M.img === ''){
                this.$refs.cropper.showFileChooser();
            }else{
                this.$refs.cropper.showModal();
            }
        },
        cropUploadSuccess (imageUrl, field) {
            this.M.img = imageUrl;
        },
        /************************/

        resetComponentData () {
            Object.assign(this.$data, initialState());
        },
    },
}
</script>

<style lang="scss">
    #account {
        max-width: 1300px !important;

        & .multiselect__content-wrapper .multiselect__content{
            max-width: 700px;
        }
    }
    .hidden-url {
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
    .deleted {
        text-decoration: line-through black;
    }
    .user-section {
        &__buttons {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-top: .3rem;
        }
        &__cell {
            width: 150px;
        }
    }
    .pricelist {
        &__files {
            display: flex;
            flex-direction: column;
            margin-left: 1rem;
        }
        &__file {
            font-weight: bold;
        }
    }
    .option-list .option:not(:last-child):after {
        content: ',';
    }
</style>
